<template>
  <v-container fluid>
    <v-row>
      <v-col class="d-flex flex-row align-center">
        <v-btn @click="()=>{$router.go(-1)}" text><v-icon>mdi-arrow-left</v-icon></v-btn>
        <h1>Reporting</h1>
        <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row v-if="!loader">
      <v-col class="d-flex flex-row flex-wrap align-center">
        <v-btn class="mr-2" @click="$router.push(`/reporting/tailorCosts`)">Revenue and Tailor</v-btn>
        <v-btn v-for="(btn, b) of customReports" :key="b+'custom'" class="mr-2 my-1" :color="(btn.metadata && btn.metadata.color)?btn.metadata.color:''" @click="$router.push(`/reporting/${btn.route}`)"><v-icon v-if="(btn.metadata && btn.metadata.icon)">{{btn.metadata.icon}}</v-icon>{{(btn.metadata && btn.metadata.label)?btn.metadata.label:'No Label'}}</v-btn>
      </v-col>
    </v-row>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
import {mapGetters} from "vuex";
import axios from "axios";
export default {
  data () {
    return {
      isEditable: false,
      loader: true,

      snackObj: {
        color: '',
        text: ''
      },

      customReports: [],
    }
  },
  async mounted(){
    try{
      this.loader = true;

      let res = await axios.get(`${this.getEndpoint}/api/custom/getCustomReports`)
      if(res.data.error) throw res.data.error
      this.customReports = res.data.data
    }
    catch (error) {
      console.error(error);
      this.snack(error.msg || error, "error");
    }
    finally {
      this.loader = false;
    }
  },
  computed: {
    ...mapGetters(['getEndpoint'])
  },
  methods: {
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
  }
}
</script>
